module.exports = __webpack_public_path__ + "img/ai-weapon1.2f8bc001.png";